// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const TrafficconfigDesiredTrafficState = {
  DesiredTrafficStateEnabled: 'enabled',
  DesiredTrafficStateDisabled: 'disabled',
} as const;
export type TrafficconfigDesiredTrafficState =
  (typeof TrafficconfigDesiredTrafficState)[keyof typeof TrafficconfigDesiredTrafficState];

export function instanceOfTrafficconfigDesiredTrafficState(
  value: any,
): boolean {
  for (const key in TrafficconfigDesiredTrafficState) {
    if (
      Object.prototype.hasOwnProperty.call(
        TrafficconfigDesiredTrafficState,
        key,
      )
    ) {
      if (
        TrafficconfigDesiredTrafficState[
          key as keyof typeof TrafficconfigDesiredTrafficState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function TrafficconfigDesiredTrafficStateFromJSON(
  json: any,
): TrafficconfigDesiredTrafficState {
  return TrafficconfigDesiredTrafficStateFromJSONTyped(json, false);
}

export function TrafficconfigDesiredTrafficStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigDesiredTrafficState {
  return json as TrafficconfigDesiredTrafficState;
}

export function TrafficconfigDesiredTrafficStateToJSON(
  value?: TrafficconfigDesiredTrafficState | null,
): any {
  return value as any;
}

export function TrafficconfigDesiredTrafficStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): TrafficconfigDesiredTrafficState {
  return value as TrafficconfigDesiredTrafficState;
}
